/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ChannelInventoryConfiguration } from '@msdyn365-commerce/retail-proxy';
import { getInventoryConfigurationAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/StoreOperationsDataActions.g';

/**
 * GetInventoryConfiguration Input Action
 */
export class GetInventoryConfigurationInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => '';
    public getCacheObjectType = () => 'ChannelInventoryConfiguration';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetInventoryConfigurationInput();
};

async function action(input: GetInventoryConfigurationInput, ctx: Msdyn365.IActionContext): Promise<ChannelInventoryConfiguration> {
    const channelInventoryConfiguration = getInventoryConfigurationAsync({ callerContext: ctx });
    return channelInventoryConfiguration;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<Promise<ChannelInventoryConfiguration>>>action,
    id: 'src/actions/get-inventory-configuration',
    input: createInput
});
